import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentService } from '@services/environment-service/environment.service';
import { ErrorHandlerService } from '@services/error-handler/error-handler.service';
import { WindowService } from '@services/window/window.service';

@Injectable({
  providedIn: 'root',
})
export class ChatbotScriptService {
  private loaded: boolean = false;
  private showOnLoaded: boolean = false;
  readonly environment = EnvironmentService.environment;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private errorHandlerService: ErrorHandlerService,
  ) {
    const kindlyScript = this.document.getElementById('kindly-chat');

    if (kindlyScript) return;

    const kindlyOptions = this.document.createElement('script');
    kindlyOptions.id = 'kindlyOptions';

    kindlyOptions.innerText = `window.kindlyOptions = {language: "${this.document.location.pathname.substring(
      1,
      3,
    )}", position: {bottom: '65px',right: '30px' }};`;

    this.document.body.appendChild(kindlyOptions);

    const script = this.document.createElement('script');
    script.id = 'kindly-chat';
    script.src = this.environment.kindlyChat.scriptUrl;
    script.setAttribute('data-bot-key', this.environment.kindlyChat.botId);
    script.setAttribute('data-shadow-dom', '1');
    script.setAttribute('data-bubble-hidden', 'true');
    script.setAttribute(
      'data-language',
      `${this.document.location.pathname.substring(1, 3)}`,
    );
    script.defer = true;

    this.document.body.appendChild(script);

    this.document.addEventListener('kindly:load', () => {
      this.loaded = true;
      if (this.showOnLoaded) {
        try {
          WindowService.showKindlyBubble(true);
          this.showOnLoaded = false;
        } catch (error) {
          if (error instanceof TypeError) {
            this.errorHandlerService.handleError(error);
          }
        }
      }
    });
  }

  handleChatbotScript(visible: boolean): void {
    const kindlyScript = this.document.getElementById('kindly-chat');
    if (kindlyScript && this.loaded) {
      try {
        WindowService.showKindlyBubble(visible);
      } catch (error) {
        if (error instanceof TypeError) {
          this.errorHandlerService.handleError(error);
        }
      }
    } else if (visible) {
      this.showOnLoaded = true;
    }
  }
}
